export const shrinkFont = (className, initial, parent, callback) => {
	const baseNode = parent ? parent : document;
	const elements = baseNode.getElementsByClassName(className);
	for (let i = 0; i < elements.length; i++) {
		const elm = elements[i];
		let fontSize = initial || parseInt(elm.style.fontSize.replace('px', ''), 10);
		elm.style.fontSize = `${fontSize}px`;
		while (fontSize > 5 && elm.offsetWidth > elm.parentElement.clientWidth) {
			fontSize--;
			elm.style.fontSize = `${fontSize}px`;
		}
	}

	callback && callback();
};

export const truncateText = (className, parent, extra, callback) => {
	const baseNode = parent ? parent : document;
	const elements = baseNode.getElementsByClassName(className);
	const width = parent.clientWidth - extra;
	for (let i = 0; i < elements.length; i++) {
		const elm = elements[i];
		elm.style.maxWidth = `${width}px`;
	}

	callback && callback();
};

export const arrangeTiles = (className, parent, callback) => {
	const baseNode = parent ? parent : document;

	const nodes = [...baseNode.getElementsByClassName(className)];
	if (nodes.length === 0) return;

	nodes.forEach(n => {
		n.style.height = 'auto';
	});

	let maxHeight = 0;

	const setHeightOnNodes = nodes => {
		maxHeight = nodes.reduce((p, c) => {
			return c.clientHeight > p ? c.clientHeight : p;
		}, 0);

		nodes.forEach(n => {
			n.style.height = `${maxHeight}px`;
		});
	};

	const group4 = nodes[0].classList.contains('group-4');

	if (group4) {
		for (let x = 0; x < nodes.length; x += 4) {
			let end = x * 4 + 4 >= nodes.length ? nodes.length - 1 : x * 4 + 4;
			const subNodes = nodes.slice(x, x + 4);
			setHeightOnNodes(subNodes);
		}
	} else {
		setHeightOnNodes(nodes);
	}

	callback && callback(maxHeight);
};

export const matchWidth = (className, parent, callback) => {
	const baseNode = parent ? parent : document;

	const nodes = [...baseNode.getElementsByClassName(className)];
	if (nodes.length === 0) return;

	nodes.forEach(n => {
		n.style.width = 'auto';
	});

	let maxWidth = 0;

	const setWidthOnNodes = nodes => {
		maxWidth = nodes.reduce((p, c) => {
			return c.clientWidth > p ? c.clientWidth : p;
		}, 0);

		nodes.forEach(n => {
			n.style.width = `${maxWidth}px`;
		});
	};

	setWidthOnNodes(nodes);

	callback && callback(maxWidth);
};

export const getEventButton = (e, maxDepth = 3) => {
	let elm = e.target;
	let safety = 0;
	while (elm.nodeName !== 'BUTTON' && safety < maxDepth) {
		elm = elm.parentElement ?? elm;
		safety++;
	}

	return elm;
};
